import 'parsleyjs/dist/parsley'
import Vue from 'vue'
import Validators from './validators'

Vue.use(Validators)



// WEBPACK FOOTER //
// ./src/configs/parsleyjs/index.js